import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {DataConnectionType} from '../types'

type Variables = {plantCode: string; storageId: number; type: DataConnectionType}

export const useDeleteStorageDataConnection = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: void, variables: Variables) => void
} = {}) =>
  useMutation<void, AxiosError, Variables>({
    mutationFn: async ({plantCode, storageId, type}) => {
      await ApiClient.axiosInstance.delete<void>(
        `/plants/${plantCode}/material-storage/${storageId}/details/${type}`
      )
    },
    onError,
    onSuccess
  })
